exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-content-template-js": () => import("./../../../src/templates/contentTemplate.js" /* webpackChunkName: "component---src-templates-content-template-js" */)
}

